namespace encrypt {
  export const IV = "s6eQW1vmcsXINrWR"
  export const KEY = "JHf0Q7YWxcE47bpl"
}
export default encrypt
